import React from 'react';

const UserContext = React.createContext({
  authenticated: false,
  data: {}
});

export default UserContext;